// Turn-phase intent builders (server-authoritative turn steps). Each returns a
// { domain:'turn', kind, ... } object the server's match:intent handler routes
// into turnService. Keep payload shapes in lockstep with
// valkenhall-server/src/match/turnService.js.

// Heal step: at the END phase every in-play non-Site, non-Avatar minion heals to
// its live baseLife plus any manual buff (manualLifeDelta). The acting client
// still runs its local heal loop for HUD visuals; this intent moves the AUTHORITY
// server-side (the server computes the heal and the opponent renders the resulting
// diff, replacing the per-card stat MIRROR broadcast). Authz rejects it from any
// non-active seat.
export function healIntent(seat) {
  return { domain: 'turn', kind: 'heal', seat };
}
